import './styles.css';
import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';

import { DEFAULT_CONFIGS } from './configs/default_configs';

import { MdOutlineMail } from 'react-icons/md';
import { AiOutlineExclamationCircle } from 'react-icons/ai';
import { useKeysStore } from '../../../store/useKeysStore';
import config from '../../../../application/config/config';

function ForgotPassword() {
    const { keys } = useKeysStore();

    const RECAPTCHA_SECRET_KEY = keys?.tokens?.recaptcha_secret;

    const [screenConfigs, setScreenConfigs] = useState(DEFAULT_CONFIGS);

    const inputRef = useRef(null);

    const [requestSent, setRequestSent] = useState(false);
    const [errorMessage, setErrorMessage] = useState(null);

    let [form, updateForm] = useState({
        email: '',
        captcha: ''
    });

    const isValidEmail = () => {
        const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
        const isValid = emailRegex.test(form.email);

        return isValid;
    };

    const handleChange = (event) => {
        if (event.target.type === 'checkbox') {
            return updateForm({
                ...form,
                [event.target.name]: event.target.checked
            });
        }
        updateForm({ ...form, [event.target.name]: event.target.value });
    };

    const handleSubmit = async (event) => {
        event.preventDefault();

        setErrorMessage(null);

        if (form.email.trim() === '') {
            return setErrorMessage('Campo de e-mail vazio');
        }

        if (!isValidEmail()) {
            return setErrorMessage('E-mail Inválido');
        }

        axios
            .post(`${config.endpoints.backend}core/sendemails/sendemail`, form)
            .then((resp) => {
                setErrorMessage(null);
                setRequestSent(true);
            })
            .catch((err) => {
                return setErrorMessage(err.response.data.msg);
            });
    };

    const loadScreenConfigs = async () => {
        const currentURL = window.location.href;
        const requestData = { urlVa: currentURL };
    
        axios.post(`${config.endpoints.backend}core/loginconfigs/getloginconfigs`, requestData).then((resp) => {
                let server_configs = resp.data;

                if (server_configs.logo_img) {
                    server_configs.logo_img = server_configs.logo_img;
                } else {
                    server_configs.logo_img = DEFAULT_CONFIGS.logo_img;
                }

                if (server_configs.isotype_img) {
                    server_configs.isotype_img = server_configs.isotype_img;
                } else {
                    server_configs.isotype_img = DEFAULT_CONFIGS.isotype_img;
                }

                if (server_configs.background_img) {
                    server_configs.background_img =
                        server_configs.background_img;
                } else {
                    server_configs.background_img =
                        DEFAULT_CONFIGS.background_img;
                }

                setScreenConfigs(server_configs);
            });
    };

    // reCaptcha
    useEffect(() => {
        const script = document.createElement('script');
        script.src = `https://www.google.com/recaptcha/api.js?render=${RECAPTCHA_SECRET_KEY}`;
        script.addEventListener('load', () => {
            window.grecaptcha.ready(() => {
                window.grecaptcha
                    .execute(RECAPTCHA_SECRET_KEY)
                    .then((token) => updateForm({ ...form, captcha: token }));
            });
        });
        document.body.appendChild(script);
    }, [errorMessage , RECAPTCHA_SECRET_KEY]);

    useEffect(() => {
        loadScreenConfigs();

        const handleKeyPress = (event) => {
            if (event.key === 'Enter') {
                inputRef.current.click();
            }
        };

        // Adiciona o listener de evento para capturar a tecla "Enter" pressionada
        document.addEventListener('keypress', handleKeyPress);

        // Remove o listener de evento quando o componente é desmontado
        return () => {
            document.removeEventListener('keypress', handleKeyPress);
        };
    }, []);

    const overlayColor = () => {
        const banner_overlay_opacity = screenConfigs.banner_overlay_opacity;

        const transparencyValue = banner_overlay_opacity
            ? banner_overlay_opacity > 100
                ? 100
                : banner_overlay_opacity < 0
                ? 0
                : banner_overlay_opacity
            : 0;

        const alphaValue = Math.round((transparencyValue / 100) * 255);
        const hexOpacity = alphaValue
            .toString(16)
            .toUpperCase()
            .padStart(2, '0');
        const backgroundColor = `${screenConfigs.banner_primary_color}${hexOpacity}`;

        return backgroundColor;
    };

    if (requestSent) {
        return (
            <div className="forgotpassword-main-container">
                <div className="forgotpassword-form-container">
                    <a href="#">
                        <img
                            src={screenConfigs.isotype_img}
                            style={{ height: '34px' }}
                        />
                    </a>
                    <div className="login-form-header">
                        <h2 className="login-form-header-title">
                            As instruções foram enviadas ao seu e-mail!
                        </h2>
                        <p className="login-form-header-msg">
                            Confira seu e-mail para redefinir sua senha.
                        </p>
                    </div>
                    <div className="forgotpassword-form-footer">
                        <button
                            onClick={() => {
                                window.location.replace('/login');
                            }}
                            className="btn btn-outline-secondary back-button"
                        >
                            Voltar para Login
                        </button>
                    </div>
                </div>
                <div
                    className="forgotpassword-background-image"
                    style={{
                        backgroundImage: `url(${screenConfigs.background_img})`
                    }}
                >
                    <div
                        className="forgotpassword-filter-overlay"
                        style={{
                            backgroundColor:
                                screenConfigs.banner_primary_color + '80'
                        }}
                    ></div>
                </div>
            </div>
        );
    }

    return (
        <div className="forgotpassword-main-container">
            <div
                className="g-recaptcha"
                data-sitekey={RECAPTCHA_SECRET_KEY}
                data-size="invisible"
            ></div>
            <div className="forgotpassword-form-container">
                <a href="#">
                    <img
                        src={screenConfigs.isotype_img}
                        style={{ height: '34px' }}
                    />
                </a>
                <div className="login-form-header">
                    <h2 className="login-form-header-title">
                        Esqueci Minha Senha
                    </h2>
                    <p className="login-form-header-msg">
                        Receba as instruções de redefinição em seu e-mail.
                    </p>
                </div>
                <div className="forgotpassword-form-body">
                    <div className="login-form-inputs-container">
                        <form>
                            <div className="login-form-input">
                                <label htmlFor="">E-mail</label>
                                <div
                                    className="login-form-input-field"
                                    style={
                                        errorMessage
                                            ? {
                                                  borderColor: '#dc3545',
                                                  backgroundColor: '#fff1f3'
                                              }
                                            : null
                                    }
                                >
                                    <MdOutlineMail
                                        size={24}
                                        color={
                                            errorMessage ? '#dc3545' : '#808080'
                                        }
                                    />
                                    <input
                                        value={form.email}
                                        type="email"
                                        id="email"
                                        name="email"
                                        onChange={handleChange}
                                        placeholder="Insira seu e-mail"
                                        style={
                                            errorMessage
                                                ? {
                                                      boxShadow:
                                                          '0 0 0 30px #fff1f3 inset'
                                                  }
                                                : null
                                        }
                                    />
                                </div>
                                <div
                                    className="login-form-error-message"
                                    style={{ marginTop: 2 }}
                                >
                                    {errorMessage && (
                                        <>
                                            <AiOutlineExclamationCircle
                                                size={16}
                                                color={'#dc3545'}
                                            />
                                            <span>{errorMessage}</span>
                                        </>
                                    )}
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
                <div className="forgotpassword-form-footer">
                    <button
                        onClick={handleSubmit}
                        className="btn btn-primary btn-block"
                        ref={inputRef}
                        style={{
                            backgroundColor: screenConfigs.primary_color,
                            border: 'none'
                        }}
                    >
                        Enviar Instruções
                    </button>
                    <button
                        onClick={() => {
                            window.location.replace('/login');
                        }}
                        className="btn btn-outline-secondary back-button"
                    >
                        Voltar para Login
                    </button>
                </div>
            </div>
            <div
                className="forgotpassword-background-image"
                style={{
                    backgroundImage: `url(${screenConfigs.background_img})`
                }}
            >
                <div
                    className="forgotpassword-filter-overlay"
                    style={{ backgroundColor: overlayColor() }}
                ></div>
            </div>
        </div>
    );
}

export default ForgotPassword;
